/** @jsx jsx */
import React, { Fragment, useContext } from 'react'
import { Flex, jsx, Heading, Box } from 'theme-ui'
import theme from '../../gatsby-plugin-theme-ui'
import { useWindowSize } from '../../hooks/useWindowSize'
import { LoopContext } from '../Layout'
import { ADD_TO_CART_BUTTON_HEIGHT } from '../product/AddToCartButton'
import Button from '../shared/Buttons/Button'
import Body from '../shared/Typography/Body/Body'

const LoopIndicator = () => {
  const {
    loop_total,
    isLoopCart,
    loop_redirect_url,
    checkoutButtonIsFixed,
  } = useContext(LoopContext)
  const { mobile } = useWindowSize()
  if (!isLoopCart) {
    return <Fragment />
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bg: 'black',
        p: [12, 12, 18],
        px: 18,
        color: 'white',
        bottom: checkoutButtonIsFixed && mobile ? ADD_TO_CART_BUTTON_HEIGHT : 0,
        right: 0,
        left: 0,
        zIndex: theme.zIndex[5],
      }}
    >
      <Flex
        sx={{
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: 'pageMaxWidth',
          margin: 'auto',
        }}
      >
        <Body
          sx={{
            color: 'white',
            fontSize: [1, 2, 3],
            fontWeight: 'normal',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
          variant="body1"
        >
          You have
          <Heading as="h4" variant="bold" sx={{ color: 'white', mx: 10 }}>
            ${loop_total / 100}
          </Heading>{' '}
          in available credit
        </Body>
      </Flex>
    </Box>
  )
}

export default LoopIndicator
